module.exports = __webpack_public_path__ + "img/training_item_desc.84527971.png";